import type { DimensionRating, Rating } from '@/types/assetCheck'

interface DimensionRowProps {
  label: string
  rating: DimensionRating
}

const DOT_COLORS: Record<Rating, string> = {
  green: 'bg-green-500',
  yellow: 'bg-amber-500',
  red: 'bg-red-500',
}

const LABELS: Record<Rating, string> = {
  green: 'Gut',
  yellow: 'Beachten',
  red: 'Kritisch',
}

export function DimensionRow({ label, rating }: DimensionRowProps) {
  return (
    <div
      className="flex items-start justify-between gap-4 py-2 border-b border-slate-100 last:border-b-0"
      data-testid="dimension-row"
      data-rating={rating.rating}
    >
      <div className="flex-1">
        <div className="font-medium text-slate-900">{label}</div>
        {rating.findings.length > 0 && (
          <div className="text-sm text-slate-600 mt-0.5">{rating.findings[0]}</div>
        )}
      </div>
      <div className="flex items-center gap-2">
        <span className={`h-2.5 w-2.5 rounded-full ${DOT_COLORS[rating.rating]}`} aria-hidden />
        <span className="text-sm text-slate-700">{LABELS[rating.rating]}</span>
      </div>
    </div>
  )
}
